export default __webpack_public_path__ + "static/SuccessStoriesFinance-bc6907d4643920f007477e1ee70db7b2.png";